import { stringParam } from '@blockit/web-shared/router/searchCodec';
import { OnboardingRouter } from '@features/onboarding/routes/OnboardingRouter';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/_authenticated/onboarding/$')({
  // Loose: the steps read their own params (`step`, `slack_connected`, ...) and must keep them across a redirect.
  validateSearch: z.looseObject({ preview: stringParam }),
  component: OnboardingRouter,
});
